import { useTranslate } from "@/i18n";

/**
 * Landing v2 — Positioning
 * "Inte för alla." — brand stance, minimal, centered.
 */
export default function PositioningSection() {
  const t = useTranslate();
  return (
    <section className="py-24 sm:py-32">
      <div className="container max-w-xl mx-auto text-center px-5">
        <h2 className="font-display text-2xl sm:text-3xl font-semibold text-foreground tracking-[-0.015em] leading-[1.15]">
          {t("home.positioning.title")}
        </h2>
        <div className="mt-6 space-y-3 text-base sm:text-lg text-muted-foreground leading-relaxed">
          <p>{t("home.positioning.body1")}</p>
          <p>{t("home.positioning.body2")}</p>
        </div>
      </div>
    </section>
  );
}
